import { PlusIcon } from "@heroicons/react/24/solid";
import { Divider, Spinner } from "@nextui-org/react";
import Select from "react-select";
import { useBusinessServices } from "./useBusinessServices";
import { durationList } from "app/redux/businessServicesSlice";
import { InputEdit } from "app/components/inputEdit/InputEdit";
import { find, truncate } from "lodash";
import * as React from "react";
import { Collapse } from "react-collapse";
import { AddCategoryModal } from "./components/addCategoryModal/addCategoryModal";
import { AddServiceModal } from "./components/addServiceModal/addServiceModal";
import {
  AsButton,
  AsButtonLeft,
  AsIconButton,
  AsInput,
  reactSelectStyles,
} from "app/subframe";
import { EmptyState } from "app/components/emptyState";

export interface BusinessServicesProps {}

export const BusinessServices: React.FC<BusinessServicesProps> = (props) => {
  const {
    isLoading,
    businessServices,
    onServicePress,
    selectedServiceParams,
    selectedService,
    onServiceNameSave,
    duration,
    setDuration,
    price,
    setPrice,
    notes,
    setNotes,
    onUpdateService,
    isDirty,
    isUpdating,
    onServiceCategoryNameSave,
    showAddCategoryModal,
    setShowAddCategoryModal,
    showAddServiceModal,
    setShowAddServiceModal,
    onAddServiceClick,
    serviceCategoryIdForNewService,
    openCategoryIds,
    setOpenCategoryIds,
    toggleCategory,
    onArchiveServiceCategory,
    onArchiveService,
  } = useBusinessServices();

  if (isLoading) {
    return <Spinner size="lg" />;
  }

  return (
    <>
      {/*<AddCategoryModal*/}
      {/*  showAddCategoryModal={showAddCategoryModal}*/}
      {/*  setShowAddCategoryModal={setShowAddCategoryModal}*/}
      {/*  setOpenCategoryId={(id) => setOpenCategoryIds((prev) => [...prev, id])}*/}
      {/*/>*/}
      <AddServiceModal
        showAddServiceModal={showAddServiceModal}
        setShowAddServiceModal={setShowAddServiceModal}
        serviceCategoryIdForNewService={serviceCategoryIdForNewService}
      />
      <div className="flex">
        <div className="border-r-millet-400 border-r-2 h-screen bg-millet-200 w-full max-w-[240px] p-4 ">
          <AsButton
            variant="neutral-secondary"
            className="flex gap-2 w-full mb-3"
            onClick={() => setShowAddCategoryModal(true)}
          >
            <PlusIcon className="w-4 h-4 stroke-black" />
            <p className="text-body-bold font-body-bold text-neutral-900">
              Add Category
            </p>
          </AsButton>

          <div className="flex flex-col gap-2">
            {businessServices.map((serviceCategory) => (
              <div key={serviceCategory.id}>
                <AsButton
                  variant="ghost"
                  className="w-full border-none flex justify-between rounded-sm text-left"
                  onClick={() => toggleCategory(serviceCategory.id)}
                  trailingIcon={
                    openCategoryIds.includes(serviceCategory.id)
                      ? "FeatherChevronUp"
                      : "FeatherChevronDown"
                  }
                  text={serviceCategory.name}
                />
                <Collapse
                  isOpened={openCategoryIds.includes(serviceCategory.id)}
                >
                  {serviceCategory?.services?.map((service: any) => (
                    <AsButtonLeft
                      variant="ghost"
                      key={service.id}
                      size="sm"
                      className="ml-3 w-11/12 justify-start text-left outline-none"
                      onClick={() =>
                        onServicePress({
                          serviceId: service.id,
                          categoryName: serviceCategory.name,
                          categoryId: serviceCategory.id,
                        })
                      }
                    >
                      <p className="text-sm">
                        {" "}
                        {truncate(service.title, {
                          length: 20,
                          omission: "..",
                        })}
                      </p>
                    </AsButtonLeft>
                  ))}
                  <AsButtonLeft
                    variant="ghost"
                    className="ml-3 w-11/12 justify-start"
                    onClick={() => onAddServiceClick(serviceCategory.id)}
                    leadingIcon={"FeatherPlus"}
                  >
                    <p className="text-sm font-semibold">Add Service</p>
                  </AsButtonLeft>
                </Collapse>
              </div>
            ))}
          </div>
        </div>

        {selectedServiceParams?.categoryId && (
          <div className="flex flex-col w-full p-4 items-center">
            <div className="flex flex-col gap-6 w-full max-w-[520px]">
              <div className="flex items-center justify-between w-full">
                <InputEdit
                  defaultValue={selectedServiceParams?.category || ""}
                  name="name"
                  containerClassName="w-full"
                  valueClassName="text-body-bold font-body-bold text-neutral-900 w-full"
                  onSave={(value) => onServiceCategoryNameSave(value)}
                />
                <AsIconButton
                  variant="destructive-ghost"
                  leadingIcon={"FeatherTrash"}
                  onClick={() => {
                    onArchiveServiceCategory(
                      Number(selectedServiceParams.categoryId)
                    );
                  }}
                  size="sm"
                />
              </div>

              {selectedService ? (
                <div className="flex flex-col border rounded p-4 border-neutral-50">
                  <div className="flex flex-col gap-4">
                    <div className="flex items-center">
                      <InputEdit
                        key={selectedService.id}
                        defaultValue={selectedService.title}
                        name="title"
                        valueClassName="text-body-bold font-body-bold text-neutral-900"
                        onSave={onServiceNameSave}
                        containerClassName="w-full"
                      />
                      <AsIconButton
                        variant="destructive-ghost"
                        leadingIcon={"FeatherTrash"}
                        onClick={() => {
                          onArchiveService(
                            Number(selectedServiceParams.service)
                          );
                        }}
                        size="sm"
                        type="button"
                      />
                    </div>
                    <Divider className="mb-6 bg-neutral-50" />
                  </div>
                  <div className="flex flex-col gap-4">
                    <div className="flex w-full justify-between items-center">
                      <p className="text-body-bold font-body-bold text-neutral-900">
                        Duration
                      </p>
                      <Select
                        className="w-full max-w-[120px] z-1000"
                        value={{
                          value: duration?.duration,
                          label: duration?.label,
                        }}
                        onChange={(newValue: any) => {
                          setDuration({
                            duration: newValue.value,
                            label:
                              find(durationList, {
                                duration: newValue.value,
                              })?.label || "",
                          });
                        }}
                        options={durationList.map(({ duration, label }) => ({
                          value: duration,
                          label: label,
                        }))}
                        styles={reactSelectStyles({
                          borderContainer: true,
                        })}
                      />
                    </div>
                    <div className="flex w-full justify-between items-center">
                      <div className="w-full">
                        <p className="text-body-bold font-body-bold text-neutral-900">
                          Price
                        </p>
                      </div>
                      <div className="max-w-[120px]">
                        <AsInput
                          leading="$"
                          type="number"
                          value={price}
                          onChange={(e) => setPrice(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 w-full">
                      <p className="text-body-bold font-body-bold text-neutral-900">
                        Notes
                      </p>
                      <AsInput
                        placeholder="Enter service notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                      />
                    </div>
                    <AsButton
                      type="submit"
                      variant="neutral-secondary"
                      size="md"
                      className="w-[200px] self-end"
                      onClick={() => onUpdateService(selectedService.id)}
                      disabled={!isDirty() || isUpdating}
                      loader={isUpdating}
                      text="Update"
                    />
                  </div>
                </div>
              ) : (
                <div className="flex flex-col gap-4 justify-center items-center w-full">
                  <EmptyState />
                  <AsButton
                    text={`Add a ${selectedServiceParams?.category} service`}
                    onClick={() =>
                      onAddServiceClick(
                        Number(selectedServiceParams.categoryId)
                      )
                    }
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {businessServices.length === 0 && (
          <div className="flex flex-col gap-4 justify-center items-center h-[75dvh] w-full">
            <EmptyState />
            <AsButton
              text={"Add your first service"}
              onClick={() => setShowAddCategoryModal(true)}
            />
          </div>
        )}
      </div>
    </>
  );
};
